<template>
  <v-app>
    <router-view/>
    <docgo-snackbar />
<!--    <offline-dialog />-->
  </v-app>
</template>

<script>
import DocgoSnackbar from "@/components/base/DocgoSnackbar";
import OfflineDialog from "@/components/offline/OfflineDialog";

export default {
  name: "App",
  components: {
    DocgoSnackbar,
    // OfflineDialog
  },
  data() {
    return {
      user: {
        name: "Thiago Queiroz"
      }
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/App.vue